/** Maps CDIA / Metro 2 numeric codes (Equifax) to human-readable labels */
const CDIA_DEBT_TYPE_LABELS: Record<string, string> = {
  "00": "Auto loan",
  "01": "Unsecured loan",
  "02": "Secured loan",
  "03": "Credit line (unsecured)",
  "04": "Credit line (secured)",
  "05": "FHA home improvement loan",
  "06": "Installment sales contract",
  "07": "Charge account",
  "08": "Real estate loan",
  "09": "Equipment lease",
  "10": "Credit card",
  "11": "Utility company",
  "12": "Educational loan",
  "13": "Lease",
  "15": "Child support",
  "17": "Line of credit",
  "18": "Home equity line of credit",
  "19": "Recreational merchandise",
  "20": "Business credit card",
  "25": "Home equity loan",
  "26": "Conventional real estate mortgage",
  "27": "FHA real estate mortgage",
  "29": "Rental agreement",
  "43": "Government employee advance",
  "47": "Credit builder loan",
  "48": "Collection account",
  "65": "Government benefit",
  "67": "Government fine",
  "68": "Government fee for service",
  "69": "Government overpayment",
  "70": "Telecommunication/cellular",
  "71": "Medical debt",
  "72": "Debt consolidation",
  "73": "Personal loan",
  "77": "Deferred student loan",
  "85": "Home improvement",
  "87": "Automobile lease",
  "89": "Second mortgage",
  "90": "Medical/health care",
  "91": "Debt buyer account",
  "92": "Secured credit card",
  "93": "Insurance claim",
  "95": "Tax lien"
};

/** Maps TransUnion string codes to human-readable labels */
const TU_DEBT_TYPE_LABELS: Record<string, string> = {
  AF: "Appliance/furniture",
  AU: "Automobile",
  BC: "Business credit card",
  BL: "Revolving business lines",
  BU: "Business loan",
  CC: "Credit card",
  CH: "Charge account",
  CI: "Commercial installment",
  CL: "Credit line",
  CO: "Consolidation",
  CU: "Telecommunications/cellular",
  CV: "Conventional real estate",
  CY: "Commercial line of credit",
  DC: "Debt counseling",
  ED: "Educational",
  FH: "FHA mortgage",
  FL: "FMHA mortgage",
  GV: "Government",
  HE: "Home equity line of credit",
  HI: "Home improvement",
  IS: "Installment",
  LC: "Line of credit",
  LE: "Lease",
  LN: "Unsecured loan",
  MD: "Medical debt",
  MH: "Manufactured housing",
  MT: "Mortgage",
  NT: "Note loan",
  PS: "Partly secured",
  RA: "Rental agreement",
  RC: "Revolving charge",
  RE: "Real estate",
  RL: "Real estate (junior liens)",
  RM: "Real estate mortgage",
  SC: "Secured credit card",
  SE: "Secured",
  SL: "Student loan",
  SM: "Second mortgage",
  ST: "Secured by household goods",
  SU: "Secured loan",
  UK: "Unknown"
};

export const getDebtTypeLabel = (code: string): string =>
  TU_DEBT_TYPE_LABELS[code] ?? CDIA_DEBT_TYPE_LABELS[code] ?? code;
